import BaseCollection from "lib/collection";
import Action from "models/action";

export default BaseCollection.extend({
    mainIndex: "__key",
    model: Action,
});
